import React, { useState, useEffect } from 'react';
import { FormField, InlineAlert, Modal, SelectField, TextAreaField } from './ui';
import api from '../../services/api';

const EventFormDialog = ({ open, onClose, event, onSuccess }) => {
  const [formData, setFormData] = useState({
    event_type: 'exam',
    title: '',
    event_date: '',
    description: '',
    specific_info: '',
    location: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setError('');
    if (event) {
      setFormData({
        event_type: event.event_type || 'exam',
        title: event.title || '',
        event_date: event.event_date ? event.event_date.split('T')[0] : '',
        description: event.description || '',
        specific_info: event.specific_info || '',
        location: event.location || '',
      });
    } else {
      setFormData({
        event_type: 'exam',
        title: '',
        event_date: '',
        description: '',
        specific_info: '',
        location: '',
      });
    }
  }, [open, event]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      if (event) {
        const dataToSend = {
          title: formData.title,
          event_date: formData.event_date,
          description: formData.description,
        };
        if (event.event_type === 'exam') dataToSend.specific_info = formData.specific_info;
        if (event.event_type === 'fight') dataToSend.location = formData.location;
        await api.put(`/admin/events/${event.id}`, dataToSend);
      } else {
        const dataToSend = {
          title: formData.title,
          event_date: formData.event_date,
          description: formData.description,
        };
        if (formData.event_type === 'exam') dataToSend.specific_info = formData.specific_info;
        if (formData.event_type === 'fight') dataToSend.location = formData.location;
        const endpoint =
          formData.event_type === 'exam' ? '/admin/events/exam' : '/admin/events/fight';
        await api.post(endpoint, dataToSend);
      }
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error saving event:', err);
      setError(err.response?.data?.message || 'Error al guardar el evento');
    } finally {
      setSubmitting(false);
    }
  };

  const isExam = (event ? event.event_type : formData.event_type) === 'exam';

  return (
    <Modal
      open={open}
      title={event ? 'Editar evento' : 'Crear evento'}
      onClose={submitting ? undefined : onClose}
      footer={
        <>
          <button type="button" className="btn-admin-secondary" onClick={onClose} disabled={submitting}>
            Cancelar
          </button>
          <button type="submit" form="event-form" className="btn-admin" disabled={submitting}>
            {submitting ? 'Guardando…' : event ? 'Guardar' : 'Crear'}
          </button>
        </>
      }
    >
      <form id="event-form" className="space-y-4" onSubmit={handleSubmit}>
        {error && <InlineAlert tone="error">{error}</InlineAlert>}
        {!event ? (
          <SelectField
            id="event_type"
            label="Tipo de evento"
            value={formData.event_type}
            onChange={handleChange}
            required
            options={[
              { value: 'exam', label: 'Examen' },
              { value: 'fight', label: 'Pelea' },
            ]}
          />
        ) : (
          <FormField
            id="event_type_locked"
            label="Tipo de evento"
            value={event.event_type === 'exam' ? 'Examen' : 'Pelea'}
            onChange={() => {}}
            disabled
          />
        )}
        <FormField id="title" label="Título" value={formData.title} onChange={handleChange} required />
        <FormField
          id="event_date"
          label="Fecha"
          type="date"
          value={formData.event_date}
          onChange={handleChange}
          required
        />
        <TextAreaField id="description" label="Descripción" value={formData.description} onChange={handleChange} />
        {isExam ? (
          <TextAreaField
            id="specific_info"
            label="Información específica"
            value={formData.specific_info}
            onChange={handleChange}
            rows={3}
          />
        ) : (
          <FormField id="location" label="Ubicación" value={formData.location} onChange={handleChange} />
        )}
        {!event && (
          <InlineAlert tone="info">
            Los participantes se gestionarán después de crear el evento.
          </InlineAlert>
        )}
      </form>
    </Modal>
  );
};

export default EventFormDialog;
